const list = [];
const add = (id, cache) => {
  list.push({
    id: id || list.length,
    cache,
  });
};

const all = () => list;

module.exports = {
  add,
  all,
};
